import { IconProps } from '../IconsTypes'

const FastPickupIcon = ({
  width = 28,
  height = 28,
  viewBox = '0 0 31 32',
  color = 'none',
  className,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16.5" r="15.5" stroke="#FFD500" />
      <path
        d="M12.5937 24.301C12.4941 24.301 12.3944 24.2714 12.3057 24.2098C12.0903 24.0618 11.9957 23.7698 12.0787 23.5058L14.0785 17.1002H12.2954C11.8866 17.1002 11.5003 16.8826 11.2617 16.5178C11.0231 16.1538 10.9583 15.6826 11.0871 15.257L12.9938 9.90181C13.2143 9.17141 13.786 8.7002 14.4764 8.7002H17.7348C18.1647 8.7002 18.562 8.9362 18.7984 9.3306C19.0348 9.7258 19.0741 10.221 18.9039 10.6546L17.7872 13.5002H19.5674C20.0839 13.5002 20.5458 13.8394 20.7437 14.3642C20.9416 14.889 20.8331 15.4882 20.468 15.8898L12.9807 24.1242C12.8745 24.241 12.7349 24.301 12.5937 24.301ZM14.4757 9.901C14.1862 9.901 14.0654 10.1578 14.0189 10.3114L12.1121 15.6674C12.0961 15.7226 12.1267 15.7874 12.1463 15.8178C12.1667 15.849 12.2133 15.901 12.2947 15.901H14.3833C14.6648 15.901 14.9304 16.0514 15.094 16.3026C15.2577 16.5538 15.3007 16.8794 15.2097 17.1722L13.877 21.4426L19.6961 15.0426C19.771 14.9602 19.7528 14.8706 19.7354 14.825C19.7179 14.7794 19.6728 14.7018 19.5674 14.7018H17.4555C17.1608 14.7018 16.8888 14.5402 16.7265 14.2698C16.5643 13.9994 16.5374 13.6594 16.6538 13.3618L17.9022 10.181C17.9356 10.0946 17.9072 10.025 17.8869 9.99141C17.8665 9.95781 17.8207 9.901 17.7356 9.901H14.4757ZM14.3833 17.101H14.3906H14.3833Z"
        fill="#0F0F13"
      />
    </svg>
  )
}

export default FastPickupIcon
